import { createSelector } from 'redux-orm';
import orm from '%paysera_seat_selection/js/seatSelection/redux/model';
import {
    OBJECT_TYPE_SECTOR,
    OBJECT_TYPE_SEAT,
    OBJECT_TYPE_ROUND_TABLE,
    OBJECT_TYPE_RECTANGLE_TABLE,
    OBJECT_TYPE_ROW,
    OBJECT_TYPE_HALL,
    OBJECT_TYPE_GENERAL_ADMISSION,
    OBJECT_TYPE_SHAPE,
} from '%paysera_seat_selection/js/seatSelection/config/constants';
import dbSelector from './dbSelector';

const refreshObject = createSelector(
    orm,
    dbSelector,
    (state, object) => object,
    (
        {
            Seat,
            Sector,
            Row,
            RoundTable,
            RectangleTable,
            Hall,
            GeneralAdmission,
            Shape,
        },
        object,
    ) => {
        if (!object) {
            return null;
        }

        const { objectType, id } = object;

        if (objectType === OBJECT_TYPE_SECTOR) {
            return Sector.withId(id);
        }
        if (objectType === OBJECT_TYPE_SEAT) {
            return Seat.withId(id);
        }
        if (objectType === OBJECT_TYPE_ROUND_TABLE) {
            return RoundTable.withId(id);
        }
        if (objectType === OBJECT_TYPE_RECTANGLE_TABLE) {
            return RectangleTable.withId(id);
        }
        if (objectType === OBJECT_TYPE_ROW) {
            return Row.withId(id);
        }
        if (objectType === OBJECT_TYPE_HALL) {
            return Hall.withId(id);
        }
        if (objectType === OBJECT_TYPE_GENERAL_ADMISSION) {
            return GeneralAdmission.withId(id);
        }
        if (objectType === OBJECT_TYPE_SHAPE) {
            return Shape.withId(id);
        }

        return null;
    },
);

export default refreshObject;
